import React from "react";
import "../../styles/components/SponsorCard.scss";
import SliderPanel from "../SliderPanel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle, faTimes } from "@fortawesome/pro-light-svg-icons";
import { Button } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import {
  FieldDropSide,
  FieldInput,
  FieldInputNumber,
  FieldTextarea,
} from "../Forms";
import { get, isEmpty } from "lodash-es";
const AddressSlide = (props) => {
  const {
    setFieldValue,
    fields,
    countries,
    address,
    values,
    addressAdded,
    setAddressAdded,
    //handleChange,
    addressSlideOpen,
    setAddressSlideOpen,
    onAddressSave,
    getStatesList,
    setStateList,
    stateList,
    SearchableList,
    index,
    isLoanRequest = false,
  } = props;
  let initialValues = null;
  if (!isLoanRequest)
    initialValues = isEmpty(get(address, index))
      ? address[index][address[index].length - 1]
      : null;
  else initialValues = get(address, "0");
  const validationSchema = Yup.object().shape({
    checkPayableTo: Yup.string()
      .required(`${isLoanRequest ? "LO059" : "CM047"} : Required`)
      .max(
        150,
        `${
          isLoanRequest ? "LO060" : "CM048"
        } : Name cannot be more than 150 characters`
      ),
    address1: Yup.string()
      .required(`${isLoanRequest ? "LO061" : "CM024"} : Required`)
      .max(
        220,
        `${
          isLoanRequest
            ? "LO062  : Address should not be more than 220 characters"
            : "CM025 : Address cannot be more than 220 characters"
        }`
      ),
    city: Yup.string()
      .required(`${isLoanRequest ? "LO063" : "WL025"} : Required`)
      .max(
        35,
        `${
          isLoanRequest
            ? "LO064 : City name should not be more than 35 characters"
            : "WL026 : City name cannot be more than 35 characters"
        }`
      )
      .test(
        "city",
        `${
          isLoanRequest ? "LO065" : "WL027"
        } : City name should only have alphabets, spaces, dot, hyphen and (‘)`,
        (val) => !checkSplChar(val)
      ),
    // stateId: Yup.string().required(
    //   `${isLoanRequest ? "LO066" : "WL030"} : Required`
    // ),
    countryId: Yup.string().required(
      `${isLoanRequest ? "LO067" : "WL028"} : Required`
    ),
    // foreignCountry: Yup.string().required(
    //   `${isLoanRequest ? "LO075" : "WL039"} : Required`
    // )
    // .max(
    //   30,
    //   `${isLoanRequest
    //     ? "LO076"
    //     : "WL040"
    //   } :  Country name should not exceed 30 characters.`
    // ),
    // foreignState: Yup.string().required(
    //   `${isLoanRequest ? "LO077" : "WL041"} : Required`
    // )
    // .max(
    //   35,
    //   `${isLoanRequest
    //     ? "LO078"
    //     : "WL042"
    //   } :  State name should not exceed 35 characters.`
    // ),
    // foreignZipCode: Yup.string().required(
    //   `${isLoanRequest ? "LO079" : "WL043"} : Required`
    // ),
    // zipCode: Yup.string()
    //   .required(`${isLoanRequest ? "LO068" : "WL033"} : Required`)
    //   .test(
    //     "zipCode",
    //     `${isLoanRequest ? "LO069" : "WL032"
    //     } : ZIP Code should be in a format of XXXXX or XXXXXXXXX or XXXXX-XXXX, X being a number`,
    //     (val) => isValidZip(val)
    //   ),
    mobileNumber: Yup.string()
      .required(`${isLoanRequest ? "LO070" : "CM047"} : Required`)
      .max(
        10,
        `${
          isLoanRequest
            ? "LO071 : Mobile number should be equal 10 characters"
            : "CM048 : Mobile number cannot be more than 10 characters"
        }`
      )
      .test(
        "len",
        "LO071 : Mobile number should be equal 10 characters",
        (val) => !isLoanRequest || (val && val.length === 10)
      ),
    emailId: Yup.string()
      .required(`${isLoanRequest ? "LO072" : "WL036"} : Required`)
      .email(`${isLoanRequest ? "LO073" : "WL037"} : E-mail should be valid`)
      .max(
        80,
        `${
          isLoanRequest ? "LO074" : "WL038"
        } :Email Id should not exceed 80 characters`
      )
      .nullable(),
  });

  const checkSplChar = (val) => {
    const format = /[!@#$%^&*()_+\=\[\]{};:"\\|,<>\/?]+/;
    if (format.test(val) === true) return true;
    else return false;
  };
  const isValidZip = (val) => {
    const format = /(^\d{5}$)|(^\d{9}$)|(^\d{5}-\d{4}$)/;
    if (format.test(val) === true) {
      return true;
    } else return false;
  };

  const onFormSubmit = (values) => {
    if (!isLoanRequest) {
      setFieldValue(`[distribution]${index}.address`, values);
      onAddressSave(values, index);
    } else {
      onAddressSave(values);
    }
  };

  return (
    <SliderPanel
      isOpen={addressSlideOpen === index || (isLoanRequest && addressSlideOpen)}
      size="35"
      showCancel={false}
      backdropClicked={() => setAddressSlideOpen(null)}
    >
      <Formik
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validationSchema={validationSchema}
        validateOnBlur={false}
        initialValues={{
          ...initialValues,
          emailId: initialValues?.primaryEmailAddress,
          state: stateList.find(
            (x) => x?.stateDescription == initialValues?.state
          )?.stateDescription,
          stateId: stateList.find(
            (x) => x?.stateDescription == initialValues?.state
          )?.id,
          country: countries.find((x) => x.code == initialValues?.country)
            ?.code,
          countryId: countries.find((x) => x.code == initialValues?.country)
            ?.id,
        }}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;
          return (
            <Form onSubmit={handleSubmit}>
              <div className="disp-flex-row space-between fw-500 ft-16 ">
                <p>Add Address Details</p>
                <div>
                  <Button
                    className="marg-right-10"
                    variant="secondary"
                    onClick={() => setAddressSlideOpen(null)}
                  >
                    Cancel
                  </Button>
                  <Button className="w-100px marg-right-10" type="Submit">
                    Save
                  </Button>
                </div>
              </div>
              <div className="disp-flex-col overflow-Y H-80">
                <Field
                  size="smd"
                  isRequired
                  placeholder=" "
                  label={"Make Check Payable to"}
                  name={"checkPayableTo"}
                  type="text"
                  value={values[fields.checkPayableTo]}
                  onChange={handleChange}
                  component={FieldInput}
                />
                <Field
                  size="smd"
                  isRequired
                  placeholder=" "
                  label={"Address"}
                  name={"address1"}
                  type="text"
                  value={values[fields.address1]}
                  onChange={handleChange}
                  component={FieldTextarea}
                />
                <Field
                  size="md"
                  isRequired
                  name={fields.city}
                  label={"City"}
                  type="text"
                  autoComplete="off"
                  value={values[fields.city]}
                  onChange={handleChange}
                  //disabled={isEdit && !isSave}
                  component={FieldInput}
                />

                <Field
                  size="md"
                  isRequired
                  name={fields.countryId}
                  value={values[fields.countryId]}
                  label="Country"
                  options={
                    countries &&
                    countries.map((country, index) => ({
                      label: country.code,
                      value: country.id,
                    }))
                  }
                  popupContent={
                    <SearchableList
                      label="Select Country"
                      options={
                        countries &&
                        countries.map((country, index) => ({
                          label: country.code,
                          value: country.id,
                        }))
                      }
                      onSelect={(value, label) => {
                        setFieldValue(fields.country, label);
                        setFieldValue(fields.countryId, value);
                        setFieldValue(fields.countryCode, label);
                        setFieldValue(fields.zipCode, null);
                        value == 1 &&
                          setFieldValue(fields.foreignCountry, null) &&
                          setFieldValue(fields.foreignState, null) &&
                          setFieldValue(fields.foreignZipCode, null);
                        value == 2 &&
                          setFieldValue(fields.state, null) &&
                          setFieldValue(fields.stateId, null);
                        if (value == 1)
                          getStatesList(fields.countryId)
                            .then((response) => {
                              setStateList(response);
                            })
                            .catch((error) => {
                              //Handle error
                            });
                      }}
                      value={values[fields.countryId]}
                      selectedValue={values[fields.countryId]}
                    />
                  }
                  //disabled={isEdit && !isSave}
                  component={FieldDropSide}
                />
                {values[fields.country] == "USA" && (
                  <>
                    <Field
                      size="md"
                      isRequired
                      name={fields.stateId}
                      options={
                        stateList &&
                        stateList.map((state, index) => ({
                          label: state.stateDescription,
                          value: state.id,
                        }))
                      }
                      value={values[fields.stateId]}
                      label="State"
                      direction="bottom"
                      validate={(val) =>
                        [null, undefined, ""].includes(val)
                          ? `${isLoanRequest ? "LO066" : "WL030"} : Required`
                          : undefined
                      }
                      popupContent={
                        <SearchableList
                          label="Select State"
                          options={
                            stateList &&
                            stateList.map((state, index) => ({
                              label: state.stateDescription,
                              value: state.id,
                            }))
                          }
                          onSelect={(value, label) => {
                            setFieldValue(fields.state, label);
                            setFieldValue(fields.stateId, value);
                          }}
                          selectedValue={values[fields.stateId]}
                          height="250px"
                          value={values[fields.stateId]}
                        />
                      }
                      //disabled={isEdit && !isSave}
                      component={FieldDropSide}
                    />
                    <Field
                      size="smd"
                      isRequired
                      placeholder=" "
                      label={"Zip Code"}
                      name={"zipCode"}
                      type="text"
                      value={values[fields.zipCode]}
                      validate={(val) => {
                        return [null, undefined, ""].includes(
                          values[fields.zipCode]
                        )
                          ? `${isLoanRequest ? "LO068" : "WL033"} : Required`
                          : !isValidZip(values[fields.zipCode])
                          ? `${
                              isLoanRequest ? "LO069" : "WL032"
                            } : ZIP Code should be in a format of XXXXX or XXXXXXXXX or XXXXX-XXXX, X being a number`
                          : undefined;
                      }}
                      onChange={handleChange}
                      component={FieldInput}
                    />
                  </>
                )}
                {values[fields.country] && values[fields.country] !== "USA" && (
                  <>
                    <Field
                      size="md"
                      isRequired
                      name={fields.foreignCountry}
                      label={"Foreign country"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.foreignCountry]}
                      onChange={handleChange}
                      //disabled={isEdit && !isSave}
                      component={FieldInput}
                      validate={(val) => {
                        return [null, undefined, ""].includes(
                          values[fields.foreignCountry]
                        )
                          ? `${isLoanRequest ? "LO075" : "WL039"} : Required`
                          : values[fields.foreignCountry]?.length > 30
                          ? `${
                              isLoanRequest ? "LO076" : "WL040"
                            } :  Country name should not exceed 30 characters.`
                          : undefined;
                      }}
                    />

                    <Field
                      size="md"
                      isRequired
                      name={fields.foreignState}
                      label={"Foreign state"}
                      type="text"
                      autoComplete="off"
                      value={values[fields.foreignState]}
                      onChange={handleChange}
                      //disabled={isEdit && !isSave}
                      component={FieldInput}
                      validate={(val) =>
                        [null, undefined, ""].includes(
                          values[fields.foreignState]
                        )
                          ? `${isLoanRequest ? "LO077" : "WL041"} : Required`
                          : values[fields.foreignState]?.length > 35
                          ? `${
                              isLoanRequest ? "LO078" : "WL042"
                            } :  State name should not exceed 35 characters.`
                          : undefined
                      }
                    />

                    <Field
                      size="md"
                      isRequired
                      name={fields.foreignZipCode}
                      label={"Foreign zip code "}
                      type="text"
                      autoComplete="off"
                      value={values[fields.foreignZipCode]}
                      onChange={handleChange}
                      // disabled={isEdit && !isSave}
                      component={FieldInput}
                      validate={(val) =>
                        [null, undefined, ""].includes(
                          values[fields.foreignZipCode]
                        )
                          ? `${isLoanRequest ? "LO079" : "WL043"} : Required`
                          : !isValidZip(values[fields.foreignZipCode])
                          ? `${
                              isLoanRequest ? "LO069" : "WL032"
                            } : ZIP Code should be in a format of XXXXX or XXXXXXXXX or XXXXX-XXXX, X being a number`
                          : undefined
                      }
                    />
                  </>
                )}

                <Field
                  size="smd"
                  isRequired
                  placeholder=" "
                  label={"Mobile No"}
                  name={"mobileNumber"}
                  type="text"
                  value={values[fields.mobileNumber]}
                  onChange={handleChange}
                  component={FieldInputNumber}
                />
                <Field
                  size="smd"
                  isRequired
                  placeholder=" "
                  label={"Email ID"}
                  name={"emailId"}
                  type="text"
                  value={values[fields.emailId]}
                  onChange={handleChange}
                  component={FieldInput}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </SliderPanel>
  );
};

export default AddressSlide;
